import { Alert, Paper, Stack, Text } from "@mantine/core";
import React from "react";
import { useAppSelector } from "../../../../../hooks";
import { selectMcbimSpacesQuery } from "../../issueSelectors";
import FloorplanFloorList from "./FloorplanFloorList";
import FloorplanViewer from "./FloorplanViewer";
import { selectUniqueMcbimFloors } from "./floorplanSelectors";

const IssueFloorplan: React.FC = () => {
  const floors = useAppSelector(selectUniqueMcbimFloors);
  const { isError } = useAppSelector(selectMcbimSpacesQuery);

  return (
    <Stack gap="md" p="sm" style={{ width: "100%", height: "100%", minHeight: 0 }}>
      {isError && <Alert color="red">Kunne ikke hente romdata fra MCBIM.</Alert>}

      {!isError && floors.length === 0 && (
        <Paper withBorder p="lg" radius="md">
          <Text size="sm" c="dimmed">
            Ingen etasjer tilgjengelig ennå.
          </Text>
        </Paper>
      )}

      {floors.length > 0 && (
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: "grid",
            gridTemplateColumns: "280px minmax(0, 1fr)",
            gap: "1rem",
          }}
        >
          <FloorplanFloorList />
          <FloorplanViewer />
        </div>
      )}
    </Stack>
  );
};

export default IssueFloorplan;
